import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import sqTranslations from './locales/sq.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      sq: { translation: sqTranslations }
    },
    lng: localStorage.getItem('i18nextLng') || 'sq', // Check localStorage first, default to Albanian
    fallbackLng: 'sq',
    supportedLngs: ['sq', 'en'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'cookie', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: 'i18next',
      cookieMinutes: 10080 // 7 days
    },
    react: {
      useSuspense: false
    }
  });

// Ensure Albanian is set on first load if nothing is stored
if (!localStorage.getItem('i18nextLng')) {
  localStorage.setItem('i18nextLng', 'sq');
  i18n.changeLanguage('sq');
}

export default i18n;